<template>
  <transition name="fade">
    <div class="loader-container" v-if="isLoading" v-show="isLoading">
      <div class="d-flex justify-content-center align-items-center h-100 w-100">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {

  props: {
    isLoading: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data() {
    return {
      //
    }
  },

  beforeMount() {
    this.init()
  },

  methods: {

    async init() {

    },

  }
}
</script>
